import React, { useEffect } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "./disclaimer.css";

const DisclaimerPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="disclaimer-page-wrapper">
      <Nav />
      <div style={{ marginTop: "50px" }}>
        <div className="disclaimer-wrapper">
          <div className="disclaimer-text-wrapper">
            <h5 className="sub-header-red">Info and Disclamer</h5>
            <h3 className="header">Terms & Conditions</h3>
            <h6 className="sub-header text-center" style={{ width: "48%" }}>
              Discover key information about air passenger rights and our
              compensation terms.
            </h6>
          </div>

          <div className="disclaimer-summary-wrapper">
            <div>
              <h3 className="desclaimer-header">§1 Scope of services</h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1.The Provider provides services in the scope of submission of
                  requests on behalf of passengers to airlines for the
                  settlement of their claims and the enforcement of their
                  rights, in particular in relation to Regulation (EC) No
                  261/2004 of the European Parliament and of the Council of 11
                  February 2004 establishing common rules on compensation and
                  assistance to passengers in the event of denied boarding and
                  of cancellation or long delay of flights, and repealing
                  Regulation (EEC) No 295/91.
                </p>

                <p className="desclaimer-sub-header">
                  2.The services are provided on the basis of an assignment of
                  rights, i.e. air passengers assign their claims against the
                  particular airlines to the Provider, authorizing the Provider
                  to assert claims in its own name, in exchange for which the
                  Provider charges a fee as per the further parts of these Terms
                  and Conditions.
                </p>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">§2 Definitions</h3>
              <div className="paragraph-wrapper" style={{ gap: "16px" }}>
                <p className="desclaimer-sub-header">
                  For the purpose of the cooperation between the Parties the
                  following definitions shall apply:
                </p>

                <div>
                  <h6 className="disclaimer-mid-header">Provider</h6>
                  <p
                    className="desclaimer-sub-header"
                    style={{ color: "#565A6D", marginTop: "2px" }}
                  >
                    Kevin Foglar, conducting business under the name of Foglar
                    Law Firm Kevin Foglar, registered at ul. Węgierska 33p,
                    33-340 Stary Sącz, Poland, NIP: 7343586718.
                  </p>
                </div>

                <div>
                  <h6 className="disclaimer-mid-header">Client</h6>
                  <p
                    className="desclaimer-sub-header"
                    style={{ color: "#565A6D", marginTop: "2px" }}
                  >
                    An airline passenger who has provided the Provider with a
                    signed Assignment Agreement.
                  </p>
                </div>

                <div>
                  <h6 className="disclaimer-mid-header">
                    Assignment Agreement
                  </h6>
                  <p
                    className="desclaimer-sub-header"
                    style={{ color: "#565A6D", marginTop: "2px" }}
                  >
                    A document signed between the Client and the Provider, on
                    the basis of which the Client assigns to the Provider its
                    claims against a particular airline authorizing the Provider
                    to assert claims in its own name. These Terms and Conditions
                    constitute an integral part of the Assignment Agreement.
                  </p>
                </div>

                <div>
                  <h6 className="disclaimer-mid-header">Contract</h6>
                  <p
                    className="desclaimer-sub-header"
                    style={{ color: "#565A6D", marginTop: "2px" }}
                  >
                    The entirety of the agreement between the Provider and the
                    Client, consisting of both the Assignment Agreement and
                    these Terms and Conditions.
                  </p>
                </div>

                <div>
                  <h6 className="disclaimer-mid-header">Regulation</h6>
                  <p
                    className="desclaimer-sub-header"
                    style={{ color: "#565A6D", marginTop: "2px" }}
                  >
                    Regulation (EC) No 261/2004 of the European Parliament and
                    of the Council of 11 February 2004 establishing common rules
                    on compensation and assistance to passengers in the event of
                    denied boarding and of cancellation or long delay of
                    flights, and repealing Regulation (EEC) No 295/91.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">§3 Engagement procedure</h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1. Potential clients who believe they have a claim against an
                  airline for a delayed or canceled flight may contact the
                  Provider and share the details of their claim in order to
                  assess its eligibility.
                </p>

                <p className="desclaimer-sub-header">
                  2. Upon contacting the Provider, the potential client may be
                  asked for additional documents or information in order to
                  assess the eligibility of the potential client’s claim.
                </p>

                <p className="desclaimer-sub-header">
                  3. Upon analysis of the provided information and documents the
                  Provider shall inform the potential client about the
                  eligibility (or non-eligibility) of their claim. If the
                  Provider believes the potential client may be eligible for
                  compensation, it shall provide the potential client with a
                  draft Assignment Agreement.{" "}
                </p>

                <p className="desclaimer-sub-header">
                  4. Upon the potential client’s signing and sending of a
                  scanned copy of the Assignment Agreement to the Provider, the
                  Contract between the Parties is concluded and the potential
                  client is thereafter considered a Client.{" "}
                </p>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">
                §4 Obligations of the Parties
              </h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1. In order to allow the Provider to properly provide its
                  services the Client is obliged to share to the Provider all
                  necessary information and documents.
                </p>

                <p className="desclaimer-sub-header">
                  2. By assigning the Client’s claims to the Provider the Client
                  guarantees that he is fully entitled to the claims which he is
                  assigning and that he has not engaged any third parties in the
                  scope of asserting the assigned claims (and if such a third
                  party was engaged, the Client is obliged to terminate that
                  engagement).
                </p>

                <p className="desclaimer-sub-header">
                  3. As part of the Provider’s services it shall assert the
                  Client’s claims before airlines and National Enforcement
                  Bodies as defined by the Regulation. For the avoidance of
                  doubt, the services do not include filing lawsuits in courts -
                  such services are subject to additional fees and may be
                  provided on the basis of a separate agreement between the
                  Parties.
                </p>

                <p className="desclaimer-sub-header">
                  4. As part of the Assignment Agreement the Provider shall be
                  entitled to collect compensation on behalf of the Client. The
                  Provider is obliged to transfer any such received compensation
                  to the Client, after offsetting the agreed fees for the
                  services provided.
                </p>

                <p className="desclaimer-sub-header">
                  5. The Provider is entitled to make decisions as to the
                  settlement of claims at its own discretion. The Provider may,
                  in particular, accept offers made by airlines and negotiate
                  settlements at its own discretion.{" "}
                </p>

                <p className="desclaimer-sub-header">
                  6. The Provider may authorize third parties, in particular its
                  employees and contractors, to assist it in the provision of
                  services.{" "}
                </p>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">§5 Fees</h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1. Upon the successful receipt of any compensation the
                  Provider shall charge a fee equal to 30% of the successfully
                  obtained amounts. The remaining compensation shall be
                  transferred to the bank account specified by the Client.
                </p>

                <p className="desclaimer-sub-header">
                  2. The final amount of the compensation received by the Client
                  from the Provider may further be decreased by potential bank
                  fees, currency exchange rates etc. Such amounts are charged
                  independently from the Provider’s fee specified above.
                </p>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">§6 Limitation of liability</h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1. The Provider acts with due diligence and strives to acquire
                  compensation on behalf of the Client. The Provider does not,
                  however, guarantee that his services will be successful in
                  acquiring the compensation and may therefore not be held
                  liable solely based on the fact that the services did not
                  result in receipt of compensation.{" "}
                </p>

                <p className="desclaimer-sub-header">
                  2. The Provider shall not be held liable if it receives
                  erroneous, incorrect or incomplete information from the
                  Client.{" "}
                </p>

                <p className="desclaimer-sub-header">
                  3. The Provider may only be held liable up to an amount equal
                  to the fee which would have been charged by the Provider if
                  compensation were received on behalf of the Client.
                </p>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">§7 Personal Data</h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1.Any personal data collected during the use of the Provider’s
                  services is covered by the Privacy Policy available on the
                  Provider’s website.
                </p>
              </div>
            </div>

            <div>
              <h3 className="desclaimer-header">§8 Final provisions</h3>
              <div className="paragraph-wrapper">
                <p className="desclaimer-sub-header">
                  1.The Contract between the Client and the Provider, and any
                  disputes or claims arising out of or in connection with it,
                  shall be governed by the laws of Poland. Any disputes or
                  claims arising out of or in connection with the Contract or
                  its subject matter or formation shall be subject to the
                  exclusive jurisdiction of the courts of Poland.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DisclaimerPage;
